module.exports = __webpack_public_path__ + "static/media/r6s-logo.4af0381c.png";